export const spacing = (...args) => args.map(a => `${a * 8}px`).join(' ')

export const shouldFlip = theme => theme.direction === 'rtl'
